define('adminNotificationsListHeaderToolsView',[
  'app',
  'module',
  'underscore',
  'tableHeaderFieldView',
  'template!adminNotificationsListHeaderToolsView'
], function (
  App,
  Module,  
  _,
  FieldView,
  Tpl
) {
  'use strict';

  Module.exports = FieldView.extend({
    template: Tpl,
    className: 'user-notification-preferences ' + FieldView.prototype.className,

    ui: {
      preferences: '.user-notification-preferences'
    },

    events: {
      'click @ui.preferences': 'onPreferences'
    },

    onRender: function() {

    },

    onPreferences: function () {
      App.navigate('admin/notifications/preferences', {trigger: true});
    }

  });
});

